module.exports = __webpack_public_path__ + "img/mzb_qrcode.a68bcb99.jpg";